import { render, staticRenderFns } from "./partnerStyleList.vue?vue&type=template&id=0286987c&scoped=true"
import script from "./partnerStyleList.vue?vue&type=script&lang=js"
export * from "./partnerStyleList.vue?vue&type=script&lang=js"
import style0 from "./partnerStyleList.vue?vue&type=style&index=0&id=0286987c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286987c",
  null
  
)

export default component.exports